document.addEventListener('change', function(event) {
  var target = event.target;
  if (!(target instanceof HTMLInputElement) || !target.matches('[data-ff-color]')) return;
  var section = target.closest('[data-ff-shop]');
  if (!section) return;
  var photo = section.querySelector('.ff-main-product-photo');
  var colorPhoto = section.querySelector('.ff-color-photo');
  if (!photo || !colorPhoto) return;
  var positions = {'caramel':'100% 0%', 'cocoa':'0% 100%', 'green':'100% 100%'};
  var position = positions[target.dataset.ffColor];
  photo.hidden = Boolean(position);
  colorPhoto.hidden = !position;
  if (position) {
    colorPhoto.style.backgroundPosition = position;
    colorPhoto.setAttribute('aria-label', 'FootieFlops — ' + target.dataset.ffLabel);
  }
});
